import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  paddingTop: theme.spacing(23),
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(16),
  },
  '& .HSPageTitle': {
    color: theme.palette.common.white,
    textAlign: 'center',
    marginBottom: theme.spacing(16),
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(10),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(4),
    },
  },
  '& .HSContentBox': {
    paddingBottom: theme.spacing(14),
    [theme.breakpoints.down('lg')]: {
      paddingBottom: theme.spacing(10),
    },
  },
  '& .HSBGPattern': {
    position: 'absolute',
    inset: 0,
    zIndex: -2,
  },
  '& .HSBGOverlay': {
    position: 'absolute',
    background: `linear-gradient(
        to bottom,
         ${alpha(theme.palette.background.primary, 0)} 1%,
         ${alpha(theme.palette.background.primary, 0.7)} 70%,
         ${alpha(theme.palette.background.primary, 0.9)} 85%,
         ${theme.palette.background.primary} 95%,
         ${theme.palette.background.primary} 100%
      )`,
    inset: 0,
    zIndex: -1,
  },
  '& .HSTextColumn': {
    flexDirection: 'column',
  },
  '& .HSHeadingContainer': {
    marginBottom: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
  },
  '& .HSHeadingLine1': {
    fontSize: theme.typography.pxToRem(24),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  '& .HSHeadingLine2': {
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(28),
    },
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  '& .HSParagraph': {
    color: theme.palette.text.secondary,
    fontSize: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  '& .HSImageColumn': {
    justifyContent: 'flex-end',
    [theme.breakpoints.down('lg')]: {
      justifyContent: 'center',
    },
  },
  '& .HSHeroImage': {
    borderRadius: theme.spacing(0.5),
  },
}));

export default StyledBox;
